import styles from './ContactDetails.module.scss';
import PropTypes from 'prop-types';
import SingleContact from './SingleContact/SingleContact';
import singleContactPropTypes from './SingleContact/SingleContactPropTypes';
import Accordion from 'client/components/aria/Accordion';
import { useIntl } from 'react-intl';
import { sortBy } from 'lodash';

const ContactDetails = ({ caption, contacts, type, variant, ...props }) => {
    const intl = useIntl();

    const hasSomeContactInfo = detail => (detail.singleLineAddress || '').trim().length || (detail.webForm || '').trim().length || (detail.telephoneNumber || '').trim().length || (detail.emailAddress || '').trim().length;
    const capitalisedType = type ? type.charAt(0).toUpperCase() + type.slice(1) : type;
    const sortedContacts = sortBy(contacts.filter(hasSomeContactInfo), ['departmentName', 'emailAddress', 'telephoneNumber']).map(contact => {
        return {
            ...contact,
            ...props,
            contactDetailsType: capitalisedType
        };
    });

    // Simple variant without accordion
    if (variant === 'simple') {
        return <div className={styles.contactsSimpleContainer}>
            {caption && (
                <h3 data-testid={`contactDetails.${caption}`} className={styles.captionSimple}>
                    {caption}
                </h3>
            )}
            {sortedContacts.map((contact, index) =>
                <SingleContact
                    key={contact.departmentName || index}
                    {...contact}
                    hideHeader
                    propertyLabelId='contactDetails.detail'
                    valueLabelId='contactDetails.description'
                />
            )}
        </div>;
    }

    // Default accordion variant
    const titleClassNames = [styles.title];
    if (sortedContacts.length === 1) {
        titleClassNames.push(styles.notAButton);
    }

    const title = <div className={styles.captionContainer}>
        <div><h3 data-testid={`contactDetails.${caption}`} className={styles.caption}>{caption}</h3></div>
        {sortedContacts.length > 1
            ? <div data-testid='numberOfRecords'>{sortedContacts.length} {intl.formatMessage({ id: 'contactDetails.records' })}</div>
            : null}
    </div>;

    return <Accordion title={title} numberAboveFold={1} titleClassName={titleClassNames.join(' ')} {...props}>
        {sortedContacts.map(SingleContact)}
    </Accordion>;
};

ContactDetails.propTypes = {
    caption: PropTypes.string,
    contacts: PropTypes.arrayOf(PropTypes.shape(singleContactPropTypes)),
    type: PropTypes.string,
    variant: PropTypes.oneOf(['accordion', 'simple'])
};

ContactDetails.defaultProps = {
    caption: '',
    variant: 'accordion'
};

export default ContactDetails;

export {
    ContactDetails,
    SingleContact
};
